import type { DocumentVersionSummary } from '../types';

export function resolveLogicalDocumentId(args: {
  activeProjectId?: string | null;
  currentProjectId?: string | null;
  currentConversationId?: string | null;
}): string | null {
  if (args.activeProjectId) return args.activeProjectId;
  if (args.currentProjectId) return args.currentProjectId;
  if (args.currentConversationId) return `conversation:${args.currentConversationId}`;
  return null;
}

export function resolveEffectiveVersionId(args: {
  currentVersionId?: string | null;
  displayVersions: DocumentVersionSummary[];
  fallbackVersionId?: string | null;
}): string | null {
  if (args.currentVersionId && args.displayVersions.some((v) => v.id === args.currentVersionId)) {
    return args.currentVersionId;
  }
  return args.fallbackVersionId ?? null;
}

export function versionOutsideLogicalDocument(args: {
  logicalDocumentId?: string | null;
  version?: Pick<DocumentVersionSummary, 'id' | 'projectId'> | null;
}): boolean {
  if (!args.logicalDocumentId || !args.version?.projectId) return false;
  return String(args.logicalDocumentId) !== String(args.version.projectId);
}

export function shouldPreserveSelectedVersionAfterProjectRefresh(args: {
  selectedVersionId?: string | null;
  projectVersions: Array<Pick<DocumentVersionSummary, 'id'>>;
}): boolean {
  if (!args.selectedVersionId) return false;
  return args.projectVersions.some((version) => version.id === args.selectedVersionId);
}
